import { connect } from 'react-redux';
import { IAppStoreState } from 'app_redux/types';
import { getSelectedKey, getKeyAccessCylinderCollections } from 'domain/key/redux/selectors';

import KeySummary from './key_summary';

const maptStateToProps = (state: IAppStoreState) => {
  return {
    keyData: getSelectedKey(state),
    keyAccessCylinderCollections: getKeyAccessCylinderCollections(state)
  };
};

export default connect(maptStateToProps)(KeySummary);
